<template>
    <div class="loading">
        <div class="loadingContainer6" id="loading-container">
            <div class="loading-con">
                <template v-if="storeInfo && storeInfo.guid">
                    <img class="logo" style="max-width: 120px;" v-if="storeInfo.agent && storeInfo.agent.is_use_logo" :src="storeInfo.agent.logo" alt="">
                    <template v-else>
                        <img class="logo" v-if="!isTheme1" src="./../../assets/goeatLogo.png" alt="">
                        <img class="logo" v-else src="./../../assets/goeatLogo_w.png" alt="">
                    </template>
                </template>
                <img class="loadingImg" src="./../../assets/loading.png" alt="">
                <div id="loading6">
                    <span></span> <span></span> <span></span>
                    <span></span> <span></span> <span></span>
                    <span></span> <span></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
export default {
    name: "loading",
    computed: {
        ...mapState([
            'isTheme1',
            "storeInfo"
        ])
    }
}
</script>

<style scoped src="./loading.css"></style>